import { AuctionStatusEnum } from '@apiTypes'
import { PermissionType } from '@/types/permissions'

/**
 * Maps auction status to the permission type needed for modification.
 * Mirrors backend _transport_request_draft_or_change:
 * - Draft → add_transportrequest (Contributor allowed)
 * - Non-draft → change_transportrequest (Contributor blocked)
 */
export function getAuctionModifyPermissionType(
  status: AuctionStatusEnum | null | undefined,
): PermissionType {
  if (!status || status === AuctionStatusEnum.DRAFT) return PermissionType.Create

  return PermissionType.Update
}
